var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreaLocationIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91895 0.508789L7.18262 0.527344C9.89357 0.779924 12.1407 2.94517 12.4629 5.58984C12.5905 6.63805 12.3816 7.61167 11.9863 8.53223C11.442 9.8004 10.6767 10.9271 9.8584 11.9873C9.08664 12.987 8.24987 13.9312 7.36328 14.8301L6.97852 15.2148C6.93512 15.257 6.88322 15.3024 6.81152 15.3682L6.44043 15.709L6.10254 15.335C5.38655 14.5416 4.64747 13.7521 3.9502 12.9414C3.05369 11.8989 2.23242 10.7886 1.55566 9.57617C1.18128 8.90683 0.83003 8.18478 0.643555 7.38867L0.574219 7.04297C0.373122 5.84575 0.584573 4.69 1.17969 3.63867C1.78728 2.56531 2.57972 1.74568 3.55566 1.21289C4.53126 0.680314 5.66111 0.449985 6.91895 0.508789ZM6.5 3.45508C4.89087 3.45519 3.61547 4.71169 3.61523 6.22754C3.61523 7.74423 4.89088 9.00184 6.5 9.00195C8.10818 9.00195 9.38477 7.7443 9.38477 6.22754C9.38453 4.71162 8.10819 3.45508 6.5 3.45508Z",
    stroke: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaLocationIco);
export default __webpack_public_path__ + "static/media/area--location--ico.2965641e116b61087d92d7db6bbb7f14.svg";
export { ForwardRef as ReactComponent };